/* 🤖 this file was generated by svg-to-ts */
export const siriusScalesPictogram: {
  name: 'scales_pictogram';
  data: string;
} = {
  name: 'scales_pictogram',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" style="display: block;"><path d="M24 7.5v33m-4.5 0h9m-18-24 27-6m-27 6 6 15c0 3.319-3.75 4.5-6 4.5s-6-1.181-6-4.5l6-15Zm27-6 6 15c0 3.319-3.75 4.5-6 4.5s-6-1.181-6-4.5l6-15Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`
};
